module.exports = __webpack_public_path__ + "static/media/tw.de3916ce.svg";